import type { OrderDarahJenis } from "@/types/order_darah";

export interface OrderDarahConfig {
  title: string;
  icon: string;
  anchorId: string;
  noDataText: string;
  dialogTitleBaru: string;
  dialogTitleEdit: string;
  confirmDeleteText: string;
  ringkasanHeader: string;
}

export interface OrderDarahTab {
  elemId: string;
  title: string;
  icon: string;
  anchorId: string;
  jenis: OrderDarahJenis | null;
  hasil?: boolean;
  pembatalan?: boolean;
}

export const ORDER_DARAH: Record<OrderDarahJenis, OrderDarahConfig> = {
  komponen_rujukan: {
    title: "Permintaan Komponen Darah Lainnya (Rujukan)",
    icon: "mdi-water-plus",
    anchorId: "card-komponen-rujukan",
    noDataText: "Belum ada permintaan komponen darah rujukan.",
    dialogTitleBaru: "Buat Permintaan Komponen Darah Lainnya (Rujukan)",
    dialogTitleEdit: "Permintaan Komponen Darah Lainnya (Rujukan)",
    confirmDeleteText:
      "Hapus permintaan komponen darah rujukan ini? Tindakan ini tidak dapat dibatalkan.",
    ringkasanHeader: "Komponen Diminta"
  },

  golongan_tabung: {
    title: "Permintaan Pemeriksaan Golongan Darah Metode Tabung",
    icon: "mdi-test-tube",
    anchorId: "card-golongan-tabung",
    noDataText: "Belum ada permintaan pemeriksaan golongan darah metode tabung.",
    dialogTitleBaru: "Buat Permintaan Pemeriksaan Golongan Darah Metode Tabung",
    dialogTitleEdit: "Permintaan Pemeriksaan Golongan Darah Metode Tabung",
    confirmDeleteText:
      "Hapus permintaan golongan darah ini? Tindakan ini tidak dapat dibatalkan.",
    ringkasanHeader: "Pemeriksaan"
  },

  coombs_test: {
    title: "Permintaan Pemeriksaan Coomb's Test",
    icon: "mdi-flask-outline",
    anchorId: "card-coombs-test",
    noDataText: "Belum ada permintaan pemeriksaan Coomb's Test.",
    dialogTitleBaru: "Buat Permintaan Pemeriksaan Coomb's Test",
    dialogTitleEdit: "Permintaan Pemeriksaan Coomb's Test",
    confirmDeleteText:
      "Hapus permintaan Coomb's Test ini? Tindakan ini tidak dapat dibatalkan.",
    ringkasanHeader: "Pemeriksaan"
  },

  darah_lainnya_rujukan: {
    title: "Permintaan Pemeriksaan Darah Lainnya (Rujukan)",
    icon: "mdi-send-outline",
    anchorId: "card-darah-lainnya-rujukan",
    noDataText: "Belum ada permintaan pemeriksaan darah rujukan.",
    dialogTitleBaru: "Buat Permintaan Pemeriksaan Darah Lainnya (Rujukan)",
    dialogTitleEdit: "Permintaan Pemeriksaan Darah Lainnya (Rujukan)",
    confirmDeleteText:
      "Hapus permintaan pemeriksaan darah rujukan ini? Tindakan ini tidak dapat dibatalkan.",
    ringkasanHeader: "Pemeriksaan"
  },

  plebotomi_terapi: {
    title: "Permintaan Tindakan Plebotomi Terapi",
    icon: "mdi-needle",
    anchorId: "card-plebotomi-terapi",
    noDataText: "Belum ada permintaan tindakan plebotomi terapi.",
    dialogTitleBaru: "Buat Permintaan Tindakan Plebotomi Terapi",
    dialogTitleEdit: "Permintaan Tindakan Plebotomi Terapi",
    confirmDeleteText:
      "Hapus permintaan plebotomi terapi ini? Tindakan ini tidak dapat dibatalkan.",
    ringkasanHeader: "Tindakan"
  }
};

export const ORDER_DARAH_TABS: OrderDarahTab[] = [
  {
    elemId: "order-darah-komponen",
    title: "Permintaan Komponen Darah",
    icon: "mdi-blood-bag",
    anchorId: "card-permintaan-komponen-darah",
    jenis: null
  },
  {
    elemId: "order-darah-komponen-rujukan",
    title: "Permintaan Komponen Darah Lainnya (Rujukan)",
    icon: ORDER_DARAH.komponen_rujukan.icon,
    anchorId: ORDER_DARAH.komponen_rujukan.anchorId,
    jenis: "komponen_rujukan"
  },
  {
    elemId: "order-darah-golongan-tabung",
    title: "Pemeriksaan Golongan Darah Metode Tabung",
    icon: ORDER_DARAH.golongan_tabung.icon,
    anchorId: ORDER_DARAH.golongan_tabung.anchorId,
    jenis: "golongan_tabung"
  },
  {
    elemId: "order-darah-coombs-test",
    title: "Pemeriksaan Coomb's Test",
    icon: ORDER_DARAH.coombs_test.icon,
    anchorId: ORDER_DARAH.coombs_test.anchorId,
    jenis: "coombs_test"
  },
  {
    elemId: "order-darah-darah-lainnya-rujukan",
    title: "Pemeriksaan Darah Lainnya (Rujukan)",
    icon: ORDER_DARAH.darah_lainnya_rujukan.icon,
    anchorId: ORDER_DARAH.darah_lainnya_rujukan.anchorId,
    jenis: "darah_lainnya_rujukan"
  },
  {
    elemId: "order-darah-plebotomi-terapi",
    title: "Permintaan Tindakan Plebotomi Terapi",
    icon: ORDER_DARAH.plebotomi_terapi.icon,
    anchorId: ORDER_DARAH.plebotomi_terapi.anchorId,
    jenis: "plebotomi_terapi"
  },
  {
    elemId: "order-darah-hasil-bank-darah",
    title: "Hasil Pemeriksaan Bank Darah",
    icon: "mdi-water-check",
    anchorId: "card-hasil-bank-darah",
    jenis: null,
    hasil: true
  },
  {
    elemId: "order-darah-pembatalan-komponen",
    title: "Pembatalan Komponen Darah",
    icon: "mdi-water-remove",
    anchorId: "card-pembatalan-komponen-darah",
    jenis: null,
    pembatalan: true
  }
];

export const ORDER_DARAH_SUB_TABS: string[] = ORDER_DARAH_TABS.map(
  tab => tab.elemId
);
